// extracted by mini-css-extract-plugin
export default {"container":"_2k9v8D1k no-export","notificationWrapper":"MH3AH1M1","notification":"_15lTsewR","close":"_2UGXgjS5"};